import { sharedLib } from "@shared/services/shared.service";
import {
  DisplayResultMessage,
  ExternalAccountType,
  LanguageNameSpaces,
  OpenConfirmModal,
} from "@shared/types";
import { ReactNode } from "react";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface useDisconnectExternalAccountProps {
  useConfirmModal: ({ loading }: { loading: boolean }) => {
    confirmModalContextHolder: ReactNode;
    openConfirmModal: OpenConfirmModal;
  };
  displayResultMessage: DisplayResultMessage;
}

const useDisconnectExternalAccount = ({
  useConfirmModal,
  displayResultMessage,
}: useDisconnectExternalAccountProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.SETTINGS);
  const [disconnectTelegramAccount, { isLoading: disconnectTelegramLoading }] =
    sharedLib.sharedApi.settings.useDisconnectTelegramAccountMutation();
  const [disconnectDiscordAccount, { isLoading: disconnectDiscordLoading }] =
    sharedLib.sharedApi.settings.useDisconnectDiscordAccountMutation();
  const { confirmModalContextHolder, openConfirmModal } = useConfirmModal({
    loading: disconnectTelegramLoading || disconnectDiscordLoading,
  });

  const onDisconnectClick = (accountType: ExternalAccountType) => {
    const disconnectEndpoint =
      accountType === ExternalAccountType.TELEGRAM
        ? disconnectTelegramAccount
        : disconnectDiscordAccount;
    openConfirmModal(
      t("external_accounts.disconnect_confirmation", { accountType }),
      () => displayResultMessage(disconnectEndpoint().unwrap()).catch(() => {})
    );
  };

  return { onDisconnectClick, confirmModalContextHolder };
};

export default useDisconnectExternalAccount;
